import { render, staticRenderFns } from "./TomsContent.vue?vue&type=template&id=2d570456&scoped=true"
import script from "./TomsContent.vue?vue&type=script&lang=js"
export * from "./TomsContent.vue?vue&type=script&lang=js"
import style0 from "./TomsContent.vue?vue&type=style&index=0&id=2d570456&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d570456",
  null
  
)

export default component.exports